
import { Component, Vue } from 'vue-property-decorator'

/**
 * テキスト入力欄の基底コンポーネント
 */
@Component
export default class InputTextBase extends Vue {
  /**
   * 入力時のイベント
   *
   * @param event イベント
   */
  private inputEvent(event: Event): void {
    this.$emit('input', (event.target as HTMLInputElement).value)
  }
}
